import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../atomic/text/Text';

export const UnderlyingPriceExitTacticPanelHeader = () => {
  return (
    <thead>
      <tr>
        <th>
          <Body3 color={colors.lightGrey} fontWeight={700}>
            #
          </Body3>
        </th>
        <th>
          <Body3 color={colors.lightGrey} fontWeight={700}>
            Price
          </Body3>
        </th>
        <th>
          <Body3 color={colors.lightGrey} fontWeight={700}>
            Pct Qty
          </Body3>
        </th>
        <th>
          <Body3 color={colors.lightGrey} fontWeight={700}>
            +/-
          </Body3>
        </th>
      </tr>
    </thead>
  );
};
